import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi";
import { locations, brand } from "../data/siteData";
import useScrollAnimation from "../hooks/useScrollAnimation";
import "./LocationAtlas.css";

export default function LocationAtlas() {
  const [hovered, setHovered] = useState(null);
  const active = locations.find((l) => l.id === hovered);

  const sectionRef = useScrollAnimation(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".atlas__node"), {
      scale: 0.85,
      opacity: 0,
      duration: 0.9,
      stagger: 0.15,
      ease: "power3.out",
      scrollTrigger: { trigger: el, start: "top 70%" },
    });
  }, []);

  return (
    <section className="atlas section" ref={sectionRef}>
      <div className="container">
        <span className="eyebrow">Two Locations, One Grid</span>
        <h2 className="atlas__title">
          THE SOLAR
          <br />
          <span className="glow-text">ATLAS</span>
        </h2>

        <div
          className={`atlas__map ${
            active ? `atlas__map--${active.id}` : ""
          }`}
        >
          <div className="atlas__spine" aria-hidden="true">
            <span className="atlas__spine-label">{brand.name}</span>
            <span className="atlas__spine-line" />
            <span className="atlas__spine-tag">ENERGY</span>
          </div>

          <div className="atlas__nodes">
            {locations.map((loc) => (
              <Link
                to={`/locations/${loc.slug}`}
                key={loc.id}
                className="atlas__node"
                onMouseEnter={() => setHovered(loc.id)}
                onMouseLeave={() => setHovered(null)}
                onFocus={() => setHovered(loc.id)}
                onBlur={() => setHovered(null)}
                data-cursor="view"
              >
                <span className="atlas__node-glow" aria-hidden="true" />
                <span className="atlas__node-code">{loc.code}</span>
                <h3 className="atlas__node-name">{loc.city}</h3>
                <p className="atlas__node-preview">{loc.description}</p>
                <span className="atlas__node-link">
                  Visit location <HiArrowRight />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
